var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.002 234.583",
    style: {
      enableBackground: "new 0 0 362.002 234.583"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4CD25"
    },
    d: "M125.837,186.723c0,6.146-5.009,11.155-11.16,11.155c-6.151,0-11.16-5.009-11.16-11.155 c0-6.157,5.009-11.16,11.16-11.16C120.828,175.563,125.837,180.567,125.837,186.723 M114.677,167.21 c-10.76,0-19.513,8.753-19.513,19.513c0,10.76,8.753,19.513,19.513,19.513s19.518-8.753,19.518-19.513 C134.195,175.964,125.437,167.21,114.677,167.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4CD25"
    },
    points: "110.495,209.544 110.495,224.412 117.489,224.417 118.859,224.412 118.859,209.544  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.498,
    y: 195.088,
    style: {
      fill: "#B0DBD8"
    },
    width: 53.409,
    height: 8.363
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E94E1D"
    },
    d: "M240.125,201.683v-0.021c-0.005-0.063-0.506-6.436-3.961-12.745 c-3.149-5.756-9.459-12.614-21.651-12.614c-12.635,0-19.034,7.221-22.215,13.609c-2.591-3.128-7.115-6.541-14.562-6.541 c-14.541,0-19.113,12.619-19.502,19.297l-0.111,2.76h8.474l-0.016-2.291c0.021-0.469,0.743-11.402,11.155-11.402 c6.668,0,9.385,4.366,10.491,8.026c0.406,1.348,0.621,2.797,0.643,4.298v1.369h8.4l0.011-1.359 c0.026-3.234,0.595-5.751,1.064-7.284c1.77-5.53,6.014-12.124,16.169-12.124c16.047,0,17.222,16.758,17.264,17.459l0.095,3.339 l8.358-0.068L240.125,201.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A9EDA"
    },
    d: "M338.205,187.765l-0.179,2.233c-0.137,1.596-0.895,5.293-5.003,5.293 c-2.312,0-3.824-1.106-4.645-3.418l-0.042-0.163c-0.237-0.806-0.442-1.727-0.511-2.091c-0.358-1.754-0.937-3.049-1.253-3.676 c-1.664-3.092-5.014-6.778-11.544-6.778c-8.853,0-11.86,6.778-12.74,9.696c-0.074,0.253-0.221,0.774-0.384,1.538l-0.174,1.027 c-0.042,0.284-0.09,0.611-0.153,0.98l-0.053,0.3c-0.026,0.142-0.063,0.295-0.111,0.495c-0.132,0.537-0.311,1.011-0.532,1.433 l-0.147,0.253c-0.874,1.538-2.175,2.254-4.097,2.254c-2.38,0-3.939-1.143-4.629-3.35l-0.063-0.253 c-0.216-0.706-0.427-1.622-0.564-2.249c-0.211-1.043-0.537-2.08-0.974-3.097c-1.643-3.281-5.003-7.184-11.76-7.184 c-9.98,0-13.124,8.606-13.398,13.156l-0.137,2.486h8.353l0.179-1.986c0.032-0.537,0.453-5.246,5.003-5.246 c2.354,0,3.887,1.159,4.677,3.539c0.226,0.679,0.532,1.717,0.7,2.496c0.379,1.785,0.98,3.118,1.322,3.776 c1.691,2.881,5.024,6.309,11.292,6.309c7.858,0,11.113-5.356,12.361-8.574c0.29-0.88,0.511-1.78,0.648-2.681 c0.153-0.943,0.437-2.091,0.532-2.438c0.611-2.833,2.249-4.271,4.851-4.271c2.391,0,3.934,1.196,4.724,3.66 c0.221,0.648,0.558,1.791,0.743,2.623c0.211,1.027,0.527,2.022,0.953,2.986c1.654,3.128,5.003,6.857,11.576,6.857 c9.991,0,13.124-8.621,13.383-13.188l0.126-2.733L338.205,187.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M52.463,30.435c0-2.628,0.858-4.761,2.623-6.531c1.77-1.77,3.897-2.633,6.499-2.633 c2.512,0,4.614,0.885,6.436,2.702c1.812,1.822,2.691,3.934,2.691,6.462v0.901H52.463V30.435z M72.577,19.454 c-3.013-3.034-6.699-4.571-10.955-4.571s-7.953,1.538-10.981,4.566c-3.028,3.039-4.566,6.731-4.566,10.986v23.737h6.388V37.729 h18.249v16.442h6.394V30.435C77.106,26.179,75.584,22.482,72.577,19.454"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "92.461,27.714 89.301,24.618 86.078,27.709 86.083,54.174 92.467,54.174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "86.312,15.13 86.323,21.028 92.216,21.028 92.216,15.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "25.091,16.102 25.091,19.899 23.195,19.899 23.195,16.102 21.293,16.102 21.293,19.899  19.397,19.899 19.397,16.102 17.491,16.102 17.491,21.795 26.987,21.795 26.987,16.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "17.492,145.289 17.492,146.643 20.884,150.04 17.492,153.442 17.492,154.785  26.993,154.785 26.993,152.889 20.737,152.889 23.581,150.04 20.737,147.185 26.993,147.185 26.993,145.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "25.091,130.088 25.091,133.885 23.195,133.885 23.195,130.088 21.293,130.088  21.293,133.885 19.397,133.885 19.397,130.088 17.491,130.088 17.491,135.787 26.987,135.787 26.987,130.088  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "17.492,114.892 17.492,120.596 19.394,120.596 19.394,118.689 26.993,118.689  26.993,116.793 19.394,116.793 19.394,114.892  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M21.295,103.491h-1.901v-2.849c0-0.269,0.095-0.49,0.269-0.669c0.19-0.184,0.416-0.284,0.685-0.284 c0.263,0,0.49,0.1,0.669,0.284c0.184,0.179,0.279,0.4,0.279,0.669V103.491z M23.18,100.289c-0.084-0.706-0.395-1.306-0.943-1.78 c-0.532-0.479-1.169-0.716-1.885-0.716c-0.79,0-1.469,0.279-2.022,0.837c-0.558,0.558-0.837,1.222-0.837,2.012v4.75h9.501v-1.901 h-3.803v-0.553l3.803-3.803v-1.343H25.65L23.18,100.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M24.533,85.836c-0.369,0.369-0.816,0.558-1.343,0.558h-1.896c-0.521,0-0.969-0.19-1.343-0.558 c-0.369-0.374-0.558-0.822-0.558-1.343c0-0.521,0.19-0.959,0.558-1.338c0.374-0.374,0.822-0.558,1.343-0.558h1.896 c0.527,0,0.974,0.184,1.343,0.558c0.363,0.379,0.558,0.816,0.558,1.338C25.092,85.014,24.897,85.462,24.533,85.836 M23.19,80.696 h-1.896c-1.048,0-1.949,0.374-2.697,1.111c-0.737,0.737-1.106,1.638-1.106,2.686c0,1.059,0.369,1.949,1.106,2.686 c0.748,0.743,1.648,1.122,2.697,1.122h1.896c1.053,0,1.949-0.379,2.691-1.122c0.737-0.737,1.106-1.627,1.106-2.686 c0-1.048-0.369-1.949-1.106-2.686C25.139,81.07,24.244,80.696,23.19,80.696"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M21.294,69.292h-1.901v-2.849c0-0.263,0.095-0.49,0.274-0.669c0.184-0.184,0.411-0.279,0.679-0.279 c0.263,0,0.49,0.095,0.669,0.279c0.179,0.179,0.279,0.406,0.279,0.669V69.292z M23.19,66.443c0-0.779-0.274-1.448-0.837-2.012 c-0.558-0.553-1.222-0.832-2.007-0.832c-0.79,0-1.464,0.279-2.017,0.832c-0.558,0.564-0.832,1.232-0.832,2.012v4.756h9.496v-1.907 H23.19V66.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M24.529,51.638c-0.369,0.369-0.822,0.558-1.332,0.558H21.29c-0.516,0-0.964-0.19-1.332-0.558 c-0.379-0.369-0.564-0.816-0.564-1.338c0-0.521,0.184-0.969,0.564-1.343c0.369-0.374,0.816-0.564,1.332-0.564h1.907 c0.511,0,0.964,0.19,1.332,0.564c0.374,0.374,0.564,0.822,0.564,1.343C25.092,50.822,24.903,51.269,24.529,51.638 M23.196,46.498 H21.29c-1.048,0-1.949,0.369-2.686,1.117c-0.743,0.737-1.117,1.633-1.117,2.686c0,1.048,0.374,1.943,1.117,2.681 c0.737,0.748,1.638,1.117,2.686,1.117h1.907c1.043,0,1.938-0.369,2.686-1.117c0.737-0.737,1.111-1.633,1.111-2.681 c0-1.053-0.374-1.949-1.111-2.686C25.134,46.867,24.239,46.498,23.196,46.498"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "25.091,31.298 25.091,35.1 17.491,35.1 17.491,37.002 26.987,37.002 26.987,31.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "85.365,105.973 85.365,66.705 80.852,66.652 65.721,81.783 50.584,66.652 46.071,66.705  46.071,105.973 52.464,105.973 52.464,77.559 65.721,90.815 78.982,77.559 78.982,105.973  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M120.437,82.232v0.906h-18.254v-0.906c0-2.623,0.858-4.756,2.628-6.531 c1.759-1.77,3.887-2.633,6.494-2.633c2.517,0,4.619,0.885,6.431,2.707C119.552,77.598,120.437,79.715,120.437,82.232  M126.82,105.974V82.232c0-4.25-1.522-7.947-4.524-10.976v-0.005c-3.002-3.034-6.689-4.566-10.955-4.566 c-4.255,0-7.947,1.533-10.981,4.561c-3.028,3.039-4.566,6.731-4.566,10.986v23.742h6.388V89.516h18.254v16.458H126.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M52.461,123.252H65.67c1.38,0,2.544,0.49,3.555,1.501c1.006,1.016,1.496,2.18,1.496,3.566 c0,1.385-0.485,2.544-1.49,3.529c-1.001,0.99-2.165,1.469-3.56,1.469H52.461V123.252z M73.781,120.228 c-2.201-2.233-4.919-3.365-8.063-3.365H46.073v39.289h6.388v-16.448h13.256c3.149,0,5.862-1.122,8.058-3.323 c2.207-2.212,3.329-4.919,3.329-8.063c0-3.128-1.117-5.851-3.318-8.09H73.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M128.138,132.415c0-2.517,0.885-4.635,2.691-6.462c1.822-1.817,3.924-2.702,6.436-2.702 c2.507,0,4.608,0.885,6.425,2.702c1.817,1.828,2.697,3.945,2.697,6.462v8.19c0,2.523-0.88,4.64-2.691,6.457 c-1.817,1.822-3.924,2.707-6.431,2.707c-2.517,0-4.619-0.885-6.436-2.707c-1.806-1.817-2.691-3.934-2.691-6.457V132.415z  M137.297,116.863c-4.25,0-7.947,1.538-10.981,4.571c-3.028,3.034-4.566,6.725-4.566,10.981v8.19 c0,4.255,1.538,7.958,4.566,10.991c3.039,3.023,6.731,4.561,10.981,4.561c4.255,0,7.942-1.538,10.96-4.571 c2.997-3.034,4.519-6.725,4.519-10.981v-8.19c0-4.255-1.522-7.947-4.519-10.976C145.244,118.401,141.557,116.863,137.297,116.863"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "176.956,145.755 162.51,116.868 155.374,116.868 174.871,155.867 175.018,156.157  178.968,156.157 198.607,116.868 191.476,116.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "205.124,156.159 227.96,156.159 227.96,149.776 211.513,149.776 211.513,139.701  227.96,139.701 227.96,133.323 211.513,133.323 211.513,123.253 227.96,123.253 227.96,116.865 205.124,116.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "271.295,145.228 243.055,116.993 242.902,116.835 238.394,116.872 238.394,156.156  244.777,156.156 244.777,127.742 273.191,156.156 277.678,156.156 277.678,116.867 271.295,116.867  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M293.847,125.959c1.822-1.822,3.939-2.712,6.457-2.712c2.107,0,4.024,0.679,5.699,2.007 c1.685,1.354,2.733,3.028,3.207,5.124l0.242,1.069h6.415l-0.248-1.58c-0.59-3.729-2.359-6.862-5.256-9.317 c-2.897-2.449-6.283-3.687-10.059-3.687c-4.255,0-7.947,1.538-10.976,4.566c-3.034,3.039-4.571,6.736-4.571,10.986v8.184 c0,4.25,1.538,7.953,4.571,10.991c3.028,3.028,6.72,4.561,10.976,4.561c3.776,0,7.157-1.238,10.059-3.687 c2.897-2.444,4.666-5.577,5.256-9.306l0.248-1.58h-6.415l-0.242,1.069c-0.474,2.091-1.522,3.766-3.207,5.114 c-1.675,1.332-3.592,2.007-5.699,2.007c-2.517,0-4.635-0.885-6.457-2.707c-1.817-1.822-2.702-3.939-2.702-6.462v-8.184 C291.145,129.893,292.03,127.781,293.847,125.959"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "323.738,156.159 346.579,156.159 346.579,149.776 330.126,149.776 330.126,139.706  346.579,139.706 346.579,133.318 330.126,133.318 330.126,123.253 346.579,123.253 346.579,116.865 323.738,116.865  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M202.249,86.503c-2.207-2.233-4.914-3.365-8.058-3.365h-8.269c-1.385,0-2.544-0.479-3.534-1.464 c-0.985-0.99-1.459-2.144-1.459-3.534c0-1.396,0.479-2.565,1.475-3.576c0.985-1.006,2.133-1.49,3.518-1.49h19.65v-6.388h-19.65 c-3.144,0-5.856,1.132-8.063,3.365h-0.005c-2.196,2.238-3.313,4.956-3.313,8.09c0,3.144,1.117,5.851,3.318,8.058 c2.196,2.207,4.898,3.329,8.032,3.329h8.242c1.385,0,2.549,0.485,3.555,1.496c1.006,1.006,1.49,2.175,1.49,3.571 c0,1.385-0.479,2.544-1.485,3.518c-1.006,0.995-2.17,1.48-3.56,1.48h-19.592v6.383h19.65c3.139,0,5.851-1.122,8.053-3.329 c2.207-2.196,3.329-4.908,3.329-8.053C205.573,91.453,204.456,88.736,202.249,86.503"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "212.872,105.973 235.713,105.973 235.713,99.59 219.255,99.59 219.255,89.525  235.713,89.525 235.713,83.137 219.255,83.137 219.255,73.072 235.713,73.072 235.713,66.684 212.872,66.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "252.241,105.683 252.235,79.218 249.081,76.127 245.857,79.213 245.857,105.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "285.799,99.583 269.34,99.583 269.34,69.021 266.18,65.851 262.957,69.021 262.957,105.966  285.799,105.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "299.911,69.024 296.751,65.854 293.523,69.014 293.523,105.975 316.364,105.975  316.364,99.586 299.911,99.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "346.58,73.07 346.58,66.687 323.738,66.687 323.738,105.971 346.58,105.971 346.58,99.588  330.121,99.588 330.121,89.523 346.58,89.523 346.58,83.135 330.121,83.135 330.121,73.07  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.092,
    y: 66.635,
    style: {
      fill: "#101D2D"
    },
    width: 5.904,
    height: 5.901
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M107.532,131.841c-1.011,0.995-2.175,1.48-3.56,1.48H90.758v-10.07h13.214 c1.385,0,2.539,0.49,3.55,1.496c1.006,1.022,1.496,2.186,1.496,3.571C109.017,129.708,108.533,130.856,107.532,131.841  M104.293,139.704c3.149,0,5.862-1.117,8.063-3.323c2.212-2.207,3.334-4.919,3.334-8.063c0-3.134-1.117-5.851-3.318-8.09 c-2.207-2.228-4.919-3.36-8.058-3.36h-19.65v39.289h6.378v-16.453h3.702l16.458,16.453h4.477l0.037-4.514l-11.939-11.939H104.293z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101D2D"
    },
    d: "M143.641,73.07h13.209c1.385,0,2.549,0.49,3.55,1.501c1.006,1.006,1.496,2.175,1.496,3.565 c0,1.385-0.49,2.539-1.496,3.529c-1.001,0.99-2.159,1.475-3.55,1.475h-13.209V73.07z M143.641,89.522h3.702l16.448,16.448h4.487 l0.037-4.508L156.37,89.522h0.511c3.144,0,5.856-1.117,8.074-3.329c2.212-2.212,3.334-4.924,3.334-8.058 c0-3.123-1.122-5.846-3.323-8.084c-2.212-2.233-4.924-3.365-8.068-3.365h-19.645v39.284h6.388V89.522z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "137.039,14.855 125.431,26.457 129.977,31.002 141.579,19.4 141.568,14.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "106.803,14.855 102.268,14.865 102.258,19.4 113.865,31.008 118.405,26.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "125.432,42.586 137.034,54.188 141.574,54.183 141.585,49.643 129.977,38.041  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#101D2D"
    },
    points: "102.257,49.645 102.268,54.179 106.802,54.19 118.405,42.587 113.865,38.042  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmp);
export default __webpack_public_path__ + "static/media/logo_amp.8bec17ffb3e95a44d15224a64f9dc5f8.svg";
export { ForwardRef as ReactComponent };